import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import Loading from '../../../components/base/Loading';
import BaseForm from '../../../components/base/v2/BaseForm';
import { APIStatus } from '../../../config/CustomEnums';
import {
  removeDataFromSessionStorage,
  saveDataToSessionStorage,
} from '../../../models/MallModel';
import { createAction } from '../../../utils';
import CreateMallStepOne from './CreateMallStepOne';

function CreateMall({
  detail,
  formHasSubmitted,
  saved,
  hasUpdatedDefaultValues,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = params;

  const stepSet = [<CreateMallStepOne />];
  const goToMallList = () => history.push({ pathname: '/mall' });

  useEffect(() => {
    if (id) {
      dispatch(createAction('mall/getOneMall')({ id }));
    } else {
      dispatch({ type: 'mall/loadDataFromCookie' });
    }
  }, [dispatch, id]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'mall/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id && saved === APIStatus.success) {
      goToMallList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saved]);

  if (!detail?.id && id) {
    return <Loading customClass={'common-full-height '} />;
  }

  const getButtons = () => {
    if (history.location.search) {
      return [
        // {
        //   text: 'Back to store category list',
        //   action: () => {
        //     history.push({
        //       pathname: '/store_category',
        //     });
        //   },
        // },
        {
          text: 'Maybe Later',
          action: () => history.push('/mall'),
        },
      ];
    }
    return [
      {
        text: 'Back to mall list',
        action: () => {
          history.push({
            pathname: '/mall',
          });
        },
      },
    ];
  };

  return (
    <BaseForm
      defaultValues={detail}
      formHasSubmitted={formHasSubmitted}
      hasUpdatedDefaultValues={hasUpdatedDefaultValues}
      tempSave={(save, getValues) => {
        if (save) {
          saveDataToSessionStorage(getValues());
        } else {
          removeDataFromSessionStorage();
        }
      }}
      showFinishPop={saved === APIStatus.success}
      continueCreateConfig={{
        onConfirm: () => {
          history.push(history.location.state?.from);
        },
        onCancel: goToMallList,
        onClose: goToMallList,
      }}
      nextStepConfig={{
        title: `Successfully ${id ? 'Updated' : 'Created'}!`,
        description: `Mall is successfully ${id ? 'updated' : 'created'}.`,
        steps: null,
        onHide: () => {},
        buttons: getButtons(),
      }}
      content={stepSet}
      currentStep={0}
      breadcrumb={<CustomBreadcrumb name={id ? detail.storeName : ''} />}
      caution={{
        detail: '',
        title: id ? detail.storeName : 'Create Mall',
      }}
    />
  );
}

const mapPropsToState = (state) => ({
  detail: state.mall.detail,
  formHasSubmitted: state.mall.formHasSubmitted,
  saved: state.mall.saved,
  hasUpdatedDefaultValues: state.mall.hasUpdatedDefaultValues,
});

export default connect(mapPropsToState)(CreateMall);
